/* Missing Detail — Mystery Files
   Theme scripts */
(function(){

  /* ── Quantity steppers on product page ── */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-qty]');
    if(!btn) return;
    var wrap = btn.closest('.qty');
    if(!wrap) return;
    var input = wrap.querySelector('input');
    var delta = btn.dataset.qty === '+1' ? 1 : -1;
    input.value = Math.max(parseInt(input.dataset.min || '1', 10), (parseInt(input.value,10) || 1) + delta);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ── Product gallery thumbnails ── */
  document.addEventListener('click', function(e){
    var thumb = e.target.closest('.product__thumb');
    if(!thumb) return;
    var img = document.getElementById('productMainImage');
    if(img && thumb.dataset.image){
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = thumb.dataset.image;
      if(thumb.dataset.imageAlt){
        img.alt = thumb.dataset.imageAlt;
      }
    }
    document.querySelectorAll('.product__thumb').forEach(function(t){ t.classList.toggle('is-active', t === thumb); });
  });

  /* ── Accordion toggles (FAQ, hint categories) ── */
  document.addEventListener('click', function(e){
    var head = e.target.closest('.faq-item__q');
    if(head){
      head.closest('.faq-item').classList.toggle('is-open');
      return;
    }
    var catHead = e.target.closest('.hint-category__head');
    if(catHead){
      catHead.closest('.hint-category').classList.toggle('is-open');
    }
  });

  /* ── Cart add with fetch + toast ── */
  document.addEventListener('submit', function(e){
    var form = e.target;
    if(!(form.action || '').includes('/cart/add')) return;
    e.preventDefault();
    var data = new FormData(form);
    fetch('/cart/add.js', { method:'POST', body: data, headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(){ return fetch('/cart.js'); })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var badge = document.querySelector('[data-cart-count]');
        if(badge){ badge.textContent = cart.item_count; }
        showToast('Added to evidence bag');
      })
      .catch(function(err){ console.error(err); form.submit(); });
  });

  function showToast(msg){
    var toast = document.createElement('div');
    toast.textContent = msg;
    toast.style.cssText = [
      'position:fixed;bottom:30px;left:50%;transform:translateX(-50%);',
      'background:var(--ink);color:var(--paper);',
      'padding:14px 22px;',
      'font-family:var(--font-typewriter);font-size:12px;',
      'letter-spacing:0.22em;text-transform:uppercase;',
      'z-index:9999;box-shadow:4px 4px 0 var(--red);',
      'pointer-events:none;'
    ].join('');
    document.body.appendChild(toast);
    setTimeout(function(){ toast.remove(); }, 2400);
  }

  /* ── Mobile nav hamburger toggle ── */
  var navToggle = document.getElementById('navToggle');
  var siteNav = document.getElementById('siteNav');

  if (navToggle && siteNav) {
    navToggle.addEventListener('click', function() {
      var isOpen = siteNav.classList.toggle('is-open');
      navToggle.classList.toggle('is-open', isOpen);
      navToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    siteNav.addEventListener('click', function(e) {
      if (e.target.tagName === 'A') {
        siteNav.classList.remove('is-open');
        navToggle.classList.remove('is-open');
        navToggle.setAttribute('aria-expanded', 'false');
      }
    });

    document.addEventListener('click', function(e) {
      if (!navToggle.contains(e.target) && !siteNav.contains(e.target)) {
        siteNav.classList.remove('is-open');
        navToggle.classList.remove('is-open');
        navToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ── Analytics helper: track event to cart attributes ── */
  window.trackMD = function(eventKey, value){
    try {
      var attrs = {};
      attrs['md__' + eventKey] = value || new Date().toISOString().slice(0,19) + 'Z';
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      });
    } catch(e){}
  };

})();
